type CardPaymentState = {
  isCardComplete: boolean;
  isSubmitting: boolean;
  isCardReady: boolean;
  isDiscountCodesInvalid: boolean;
};

/**
 * Pay waits for a complete card. Enter inside the Stripe card field submits
 * the form directly, past the disabled button, so the submit handler checks
 * this too.
 */
export const isCardPaymentDisabled = ({
  isCardComplete,
  isSubmitting,
  isCardReady,
  isDiscountCodesInvalid,
}: CardPaymentState): boolean =>
  !isCardComplete || isSubmitting || !isCardReady || isDiscountCodesInvalid;

/** The card form's submit: pays only when the Pay button would let it. */
export const submitCardPayment = async <T>(
  event: Pick<Event, "preventDefault">,
  isPaymentDisabled: boolean,
  pay: () => Promise<T>
): Promise<T | null> => {
  event.preventDefault();
  if (isPaymentDisabled) {
    return null;
  }

  return pay();
};
